import { useMemo } from "react";

export const useDriverManufacturers = (races) => {
  return useMemo(() => {
    const driverRaces = {};

    races.forEach((r) => {
      if (!r.driver_name || !r.manufacturer) return;

      if (!driverRaces[r.driver_name]) {
        driverRaces[r.driver_name] = r;
      } else {
        const currentDate = new Date(driverRaces[r.driver_name].race_date);
        const newDate = new Date(r.race_date);
        if (newDate > currentDate) {
          driverRaces[r.driver_name] = r;
        }
      }
    });

    const map = {};
    Object.keys(driverRaces).forEach(driver => {
      map[driver] = driverRaces[driver].manufacturer;
    });

    return map;
  }, [races]);
};
